export default __webpack_public_path__ + "static/media/slider-img6.a8ae116a.jpg";